import { Factory } from 'rosie';
import moment from 'moment';

Factory.define('SidePanel').attr('panelShown', 'NONE').attr('panelLastShownAt', '');

Factory.define('SidePanelAnswerOpen')
  .extend('SidePanel')
  .attr('panelShown', 'ANSWER')
  .attr('panelLastShownAt', () => moment().toISOString());

Factory.define('SidePanelTaskOpen')
  .extend('SidePanel')
  .attr('panelShown', 'TASK')
  .attr('panelLastShownAt', () => moment().toISOString());
